(function () {

  'use strict';

  function initCartPageShipping() {

    const country =
      document.getElementById('cart_page_country');

    const province =
      document.getElementById('cart_page_province');

    const provinceContainer =
      document.getElementById(
        'cart_page_province_container'
      );

    const zip =
      document.getElementById('cart_page_zip');

    const button =
      document.getElementById(
        'cart-page-get-rates-submit'
      );

    const response =
      document.getElementById(
        'cart-page-wrapper-response'
      );

    if (
      !country ||
      !province ||
      !zip ||
      !button ||
      !response
    ) {
      return;
    }


    /* ==========================================
       LOAD STATES / PROVINCES
       ========================================== */

    function loadStates() {

      const selectedOption =
        country.options[country.selectedIndex];

      if (!selectedOption) return;

      const data =
        selectedOption.getAttribute('data-provinces');

      province.innerHTML =
        '<option value="">Select State</option>';

      province.disabled = true;


      if (!data || data === '[]') {

        if (provinceContainer) {
          provinceContainer.style.display = 'none';
        }

        return;
      }


      let states;

      try {

        states = JSON.parse(data);

      } catch (error) {

        console.error(
          'Province JSON error:',
          error
        );

        return;
      }


      states.forEach(function (state) {

        const option =
          document.createElement('option');

        option.value = state[0];
        option.textContent = state[1];

        province.appendChild(option);

      });


      province.disabled = false;


      if (provinceContainer) {
        provinceContainer.style.display = 'block';
      }


      /* Restore default state */

      const defaultState =
        province.getAttribute('data-default');

      if (defaultState) {

        Array.from(
          province.options
        ).forEach(function (option) {

          if (
            option.value === defaultState ||
            option.textContent === defaultState
          ) {

            province.value =
              option.value;

          }

        });

      }

    }


    country.addEventListener(
      'change',
      loadStates
    );

    loadStates();


    /* ==========================================
       CALCULATE SHIPPING
       USING SHOPIFY / jquery.cart.min.js METHOD
       ========================================== */

    button.addEventListener(
      'click',
      calculateShipping
    );


    function calculateShipping() {

      const countryValue =
        country.value;

      const provinceValue =
        province.value;

      const zipValue =
        zip.value.trim();


      /* Validation */

      if (!countryValue) {

        showError(
          'Please select a country.'
        );

        return;
      }


      if (
        !province.disabled &&
        !provinceValue
      ) {

        showError(
          'Please select a state.'
        );

        return;
      }


      if (!zipValue) {

        showError(
          'Please enter your postal code.'
        );

        return;
      }


      /* Loading */

      button.disabled = true;

      button.innerHTML =
        'Calculating...';

      response.innerHTML =
        '<p class="shipping-loading">' +
        'Calculating shipping rates...' +
        '</p>';


      /* ======================================
         SAME SHIPPING ADDRESS OBJECT
         USED BY jquery.cart.min.js
         ====================================== */

      const shippingAddress = {

        zip: zipValue,

        country: countryValue,

        province: provinceValue

      };


      console.log(
        'Shipping address:',
        shippingAddress
      );


      /* ======================================
         SHOPIFY SHIPPING RATES API
         ====================================== */

      const params = new URLSearchParams({

        'shipping_address[zip]':
          shippingAddress.zip,

        'shipping_address[country]':
          shippingAddress.country,

        'shipping_address[province]':
          shippingAddress.province

      });


      fetch(
        '/cart/shipping_rates.json?' +
        params.toString(),
        {
          method: 'GET',

          credentials: 'same-origin',

          headers: {
            'Accept':
              'application/json'
          }
        }
      )

      .then(function (res) {

        console.log(
          'Shipping rates status:',
          res.status
        );


        return res.text().then(function (text) {

          let data = {};

          try {
            data = text ? JSON.parse(text) : {};
          } catch (error) {
            console.error(
              'Invalid Shopify response:',
              text
            );
          }


          if (!res.ok) {

            const error =
              new Error(
                'Shipping rates request failed'
              );

            error.data = data;

            throw error;
          }


          return data;

        });

      })

      .then(function (data) {

        console.log(
          'Shipping response:',
          data
        );


        const rates =
          data.shipping_rates || [];


        displayShippingRates(
          rates,
          shippingAddress
        );


        resetButton();

      })

      .catch(function (error) {

        console.error(
          'Shipping calculation error:',
          error
        );


        handleShippingError(
          error
        );


        resetButton();

      });

    }


    /* ==========================================
       DISPLAY SHIPPING RATES
       ========================================== */

    function displayShippingRates(
      rates,
      shippingAddress
    ) {

      response.innerHTML = '';


      /* No rates */

      if (
        !rates ||
        !rates.length
      ) {

        response.innerHTML =
          '<p id="cart-page-shipping-rates-feedback" class="error">' +
          'No shipping rates are available for this address.' +
          '</p>';

        return;
      }


      /* Readable address */

      let readableAddress = '';


      if (shippingAddress.zip) {

        readableAddress +=
          shippingAddress.zip +
          ', ';

      }


      if (shippingAddress.province) {

        readableAddress +=
          shippingAddress.province +
          ', ';

      }


      readableAddress +=
        shippingAddress.country;


      /* ======================================
         FEEDBACK
         ====================================== */

      const feedback =
        document.createElement('p');

      feedback.id =
        'cart-page-shipping-rates-feedback';

      feedback.className =
        'success';


      if (rates.length > 1) {

        feedback.textContent =
          rates.length +
          ' shipping rates available for ' +
          readableAddress +
          ', starting at ' +
          formatRate(rates[0].price) +
          '.';

      } else {

        feedback.textContent =
          '1 shipping rate available for ' +
          readableAddress +
          '.';

      }


      response.appendChild(
        feedback
      );


      /* ======================================
         RATE LIST
         ====================================== */

      const list =
        document.createElement('ul');

      list.id =
        'cart-page-shipping-rates';


      rates.forEach(function (rate) {

        const li =
          document.createElement('li');


        const name =
          document.createElement('span');

        name.className =
          'shipping-rate-name';

        name.textContent =
          rate.name ||
          'Shipping';


        const price =
          document.createElement('strong');

        price.className =
          'shipping-rate-price';


        /* Same FREE handling as jquery.cart.min.js */

        if (
          rate.price === '0.00' ||
          parseFloat(rate.price) === 0
        ) {

          price.textContent =
            'FREE';

        } else {

          price.textContent =
            formatRate(
              rate.price
            );

        }


        li.appendChild(
          name
        );


        li.appendChild(
          document.createTextNode(' at ')
        );


        li.appendChild(
          price
        );


        list.appendChild(
          li
        );

      });


      response.appendChild(
        list
      );


      /* Show response */

      response.style.display =
        'block';

    }


    /* ==========================================
       FORMAT MONEY
       ========================================== */

    function formatRate(price) {

      const cents =
        Math.round(
          parseFloat(price) * 100
        );


      /*
       * Use Shopify.formatMoney if available
       */

      if (
        window.Shopify &&
        typeof Shopify.formatMoney === 'function'
      ) {

        const moneyFormat =
          window.cartShippingSettings &&
          window.cartShippingSettings.moneyFormat
            ? window.cartShippingSettings.moneyFormat
            : '{{ shop.money_format }}';


        return Shopify.formatMoney(
          cents,
          moneyFormat
        );

      }


      /*
       * Fallback
       */

      return parseFloat(price)
        .toFixed(2);

    }


    /* ==========================================
       SHOPIFY ERROR HANDLING
       ========================================== */

    function handleShippingError(error) {

      let message =
        'Unable to calculate shipping rates.';


      const data =
        error &&
        error.data
          ? error.data
          : null;


      if (data) {

        if (data.message) {

          message =
            data.message;

          if (data.status) {

            message +=
              ' (' +
              data.status +
              ')';

          }

          if (data.description) {

            message +=
              ': ' +
              data.description;

          }

        } else {

          const errors =
            fullMessagesFromErrors(
              data
            );


          if (errors.length) {

            message =
              errors.join('; ');

          }

        }

      }


      if (
        message ===
        'Error : country is not supported.'
      ) {

        message =
          'We do not ship to this destination.';

      }


      showError(
        message
      );

    }


    /* ==========================================
       SHOPIFY ERROR FORMAT
       ========================================== */

    function fullMessagesFromErrors(
      errors
    ) {

      const fullMessages = [];


      Object.keys(errors || {}).forEach(
        function (attribute) {

          const messages =
            errors[attribute];


          if (
            Array.isArray(messages)
          ) {

            messages.forEach(
              function (message) {

                fullMessages.push(
                  attribute +
                  ' ' +
                  message
                );

              }
            );

          }

        }
      );


      return fullMessages;

    }


    /* ==========================================
       ERROR
       ========================================== */

    function showError(
      message
    ) {

      response.innerHTML =
        '<p class="error">' +
        message +
        '</p>';

      response.style.display =
        'block';

    }


    /* ==========================================
       RESET BUTTON
       ========================================== */

    function resetButton() {

      button.disabled =
        false;

      button.innerHTML =
        'Calculate Shipping';

    }

  }


  /* ==========================================
     START
     ========================================== */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initCartPageShipping
    );

  } else {

    initCartPageShipping();

  }

})();